import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components'
import { AppImgContainer, CardContainer } from '../Reusable/CardContainer'
import { Flex, FlexColumn } from '../../Reusable/Container'
import { Image } from '../../Reusable/Image'

import BnkAppIcon from '../../../Images/product-menu/bank-menu-icon-active.png'
import CardsAppIcon from '../../../Images/product-menu/CardsActive.png'
import RcvAppIcon from '../../../Images/product-menu/receivables-menu-icon-active.png'
import PayAppIcon from '../../../Images/product-menu/payables-menu-icon-active.png'
import CrdAppIcon from '../../../Images/product-menu/credit-menu-icon-active.png'
import ApprAppIcon from '../../../Images/product-menu/approvals-menu-icon-active.png'
import ConnectionsAppIcon from '../../../Images/connections-active.svg'
import SAppIcon from '../../../Images/product-menu/settings-menu-icon.png'
import { Text } from '../../Reusable/Text'
import { getUserApps } from '../../../Utils/util'
import { connect } from 'react-redux'
import { trackEvent } from '../../../Utils/api'


class UserWelcome extends Component {
    state = {
    }

    componentDidMount() {
        
    }

    render() {
        var { store } = this.props
        const allowedApps = getUserApps(store)
        const arCreditApp = allowedApps.includes("ARCredit")
        const ablCreditApp = allowedApps.includes("ABLCredit")
        const tlCreditApp = allowedApps.includes("TermLoans")
        var Attributes = store.Attributes || {};
        const businessAttributes = Attributes.Businesses || {};

        const creditEnabled = (arCreditApp || ablCreditApp || tlCreditApp)
        var creditPath = "credit/ar-credit/advances"
        if(ablCreditApp) {
            creditPath = "credit/abl-credit/advances"
        } else if(tlCreditApp) {
            creditPath = "credit/term-loans/advances"
        }
        else if(businessAttributes.InventoryLOCEnabled){
            creditPath = "credit/inventory-loc/advances"
        }

        var appList = [{
                name: "Banking",
                imgSrc: BnkAppIcon,
                path: "banking/home"
            },{
                name: "Cards",
                imgSrc: CardsAppIcon,
                path: "cards/all"
            },{
                name: "Receivables",
                imgSrc: RcvAppIcon,
                path: "receivables/invoices"
            },{
                name: "Bill Payments",
                imgSrc: PayAppIcon,
                path: "payables/bills"
            },{
                name: "Approvals",
                imgSrc: ApprAppIcon,
                path: "approvals/pending"
            }
            // ,{
            //     name: "Connections",
            //     imgSrc: ConnectionsAppIcon,
            //     path: "settings/profile"
            // }
        ]

        const approvalsIndex = appList.findIndex(item => item.name === "Approvals");

        // Insert credit before "Approvals"
        if (creditEnabled && approvalsIndex !== -1) {
            appList.splice(approvalsIndex, 0, {
                name: "Credit",
                imgSrc: CrdAppIcon,
                path: creditPath
            })
        }

        const appSize = 70

        return (
            <CardContainer small style={{ padding: '30px 40px' }}>
                <Text weight={600} size='24px' color={this.props.theme.colors.primary2}>
                    Your Apps
                </Text>
                <Flex start gap='32px' style={{ paddingTop: '40px' }} wrap>
                    {
                        appList.map(app => (
                            <FlexColumn center gap='4px' style={{ width: appSize+15 }}>
                                <AppImgContainer 
                                    center 
                                    onClick={() => {
                                        trackEvent({ name: "dashboard_cta", property: `apps: ${(app.name || '').toLowerCase()}` });
                                        this.props.history.push(app.path);
                                    }} 
                                    style={{ width: appSize, height: appSize }}
                                >
                                    <Image height='28px' width='28px' src={app.imgSrc} />
                                </AppImgContainer>
                                <Text light size='12px'>{app.name}</Text>
                            </FlexColumn>
                            
                        ))
                    }
                    
                </Flex>
            </CardContainer>
        )
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(UserWelcome)))